// shared/experience-toggle.ts — Experience preference (V1 ↔ V3)
//
// Shared across V1 and V3. Stores preference in localStorage.
// Both experiences use this to read/write the toggle.

const EXPERIENCE_KEY = 'app-experience';

export type Experience = 'v1' | 'v3';

/** Get the current experience preference. Defaults to 'v3'. */
export function getExperience(): Experience {
  return (localStorage.getItem(EXPERIENCE_KEY) as Experience) || 'v3';
}

/** Set experience preference and redirect to the correct base path. */
export function switchExperience(exp: Experience): void {
  localStorage.setItem(EXPERIENCE_KEY, exp);
  window.location.href = exp === 'v3' ? '/v3/' : '/dashboard/';
}

/** Get the redirect path for the current experience (used after login). */
export function getExperienceHomePath(): string {
  return getExperience() === 'v3' ? '/v3/' : '/dashboard/';
}
